export default __webpack_public_path__ + "static/media/persuasion.278c9f1c.svg";